import Api from 'src/services/api'
import { getToken, setToken, removeToken, getRememberFlag, setRememberFlag } from 'src/utils/auth'
import * as Sentry from '@sentry/vue'
import { trackIssue } from 'src/boot/sentry'
// import qs from 'qs'

const rememberFlag = getRememberFlag()

const state = {
  tempToken: null,
  token: getToken(),
  accessToken: null,
  confirmationNumber: null,
  data: null,
  // reservations: null,
  reservations: undefined,
  remember: (typeof rememberFlag === 'boolean') ? rememberFlag : true
}

const getters = {
  currentToken: state => {
    if (state.token) return state.token
    else if (state.accessToken) return state.accessToken
    return null
  },
  forcedAccess: state => {
    return !state.token && state.accessToken
  },
  userId: state => {
    return state.data && state.data.id
  },
  userFullname: state => {
    if (!state.data) return ''
    let { first_name = '', last_name = '' } = state.data || {}
    return `${first_name} ${last_name}`
  }
}

const mutations = {
  SET_TOKEN: (state, token = null) => {
    state.token = token
    setToken(token)
  },
  SET_TEMP_TOKEN: (state, token) => {
    state.tempToken = token
  },
  SET_ACCESS_TOKEN: (state, token) => {
    state.accessToken = token
  },
  SET_PROFILE_DATA: (state, payload = null) => {
    const { first_name = '', last_name = '', email, phone_number, id } = payload || {}

    Sentry.configureScope(scope => {
      scope.setUser(
        id ? {
          id: id || undefined,
          username: id
            ? `${first_name} ${last_name} (${email})`
            : undefined,
          email,
          phone_number
        } : null
      )
    })
    state.data = payload
  },
  SET_RESERVATIONS_DATA: (state, payload = null) => {
    state.reservations = payload
  },
  SET_REMEMBER_FLAG: (state, payload = false) => {
    state.remember = payload
    setRememberFlag(payload)
  }
}

const actions = {
  async signin ({ commit }, payload) {
    let otpRequestResp = await Api.otpRequest(payload)
    return otpRequestResp
  },

  otpRequest ({ commit }, payload) {
    return Api.otpRequest(payload)
      .then(
        ({ data }) => {
          commit('SET_TEMP_TOKEN', data.token)
          return data
        },
        ({ response = {} }) => {
          return response.data
        }
      )
  },

  otpCheck ({ state, commit }, payload) {
    let options = {
      headers: {
        Authorization: state.tempToken
      }
    }
    return Api.otpCheck(payload, options)
      .then(
        ({ data }) => {
          commit('SET_TOKEN', data.token)
          return data
        },
        ({ response = {} }) => {
          trackIssue({ response }) // otp check failed: no such user with OTP 868132: dynamo: no item found
          return response.data
        }
      )
  },

  setUserLanguage ({ rootGetters }) {
    let language = rootGetters['language']
    return Api.updateProfile({ language })
  },

  updateUserData ({ commit, state }, payload = {}) {
    return Api.updateProfile(payload)
      .then(
        (response) => {
          commit('SET_PROFILE_DATA', response.data)
          return response
        },
        (error) => {
          return Promise.reject(error)
        }
      )
  },

  fetchUserData ({ commit, getters }) {
    if (!getters['currentToken']) {
      return new Promise(resolve => {
        commit('SET_PROFILE_DATA')
        resolve()
      })
    }
    return Api.fetchProfile()
      .then(
        ({ data }) => {
          commit('SET_PROFILE_DATA', data)
          return data
        },
        ({ response = {} }) => {
          commit('SET_PROFILE_DATA')
          return response.data
        }
      )
  },

  fetchUserReservations ({ commit, getters }) {
    if (!getters['currentToken']) {
      return new Promise(resolve => {
        commit('SET_RESERVATIONS_DATA')
        resolve()
      })
    }
    return Api.fetchReservationsList({
      params: {
        limit: 99
      }
    })
      .then(
        ({ data }) => {
          commit('SET_RESERVATIONS_DATA', data.reservations)
          return data
        },
        ({ response = {} }) => {
          console.log('FETCHING RESERVATIONS FAILURE')
          commit('SET_RESERVATIONS_DATA')
          return response.data
          // return Promise.reject(response)
        }
      )
  },

  logout ({ commit, state }) {
    return Api.signOut()
      .then(
        ({ data }) => {
          commit('SET_TOKEN')
          commit('SET_PROFILE_DATA')
          return data
        },
        ({ response = {} }) => {
          return response.data
        }
      )
  },

  resetToken ({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      removeToken()
      resolve()
    })
  },

  signinWithAccessToken ({ commit }, payload) {
    return new Promise(resolve => {
      commit('SET_ACCESS_TOKEN', payload)
      resolve()
    })
  },

  setRememberFlag ({ commit }, payload) {
    return new Promise(resolve => {
      commit('SET_REMEMBER_FLAG', payload)
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
